import type { SxProps, Theme } from '@mui/material';

export const styles = {
    dialog: { '& .MuiPaper-root': { borderRadius: '16px' } } as SxProps<Theme>,
    title: {
        textAlign: 'center',
        fontSize: '20px',
        fontWeight: 500,
        color: 'grey.900',
    } as SxProps<Theme>,
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2.5,
        py: 1,
    } as SxProps<Theme>,
    lockedPartsField: (theme: Theme): SxProps<Theme> => ({
        '& .MuiInputBase-input.Mui-disabled': {
            WebkitTextFillColor: theme.palette.grey[900],
            opacity: 1,
        },
        '& .MuiChip-root.Mui-disabled': {
            opacity: 1,
            backgroundColor: theme.palette.blue[100],
            border: `1px solid ${theme.palette.blue[200]}`,
        },
        '& .MuiChip-label': {
            color: theme.palette.grey[900],
            fontWeight: 500,
        },
    }),
    optionsLoadingRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
    } as SxProps<Theme>,
    partsLoadingRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mt: -1,
        color: 'grey.700',
    } as SxProps<Theme>,
    partsLoadingText: {
        fontSize: '12px',
        color: 'grey.700',
    } as SxProps<Theme>,
    sectionLabel: {
        fontSize: '12px',
        fontWeight: 600,
        color: 'grey.700',
        textTransform: 'uppercase',
        mt: 1,
    } as SxProps<Theme>,
    priceSection: (theme: Theme): SxProps<Theme> => ({
        border: `1px solid ${theme.palette.grey[50]}`,
        borderRadius: '8px',
        background: theme.palette.background.paper,
        p: 1.25,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
    }),
    priceHeaderRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
    } as SxProps<Theme>,
    priceTitle: {
        fontSize: '14px',
        fontWeight: 600,
        color: 'grey.900',
    } as SxProps<Theme>,
    priceToggleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
    } as SxProps<Theme>,
    priceToggleLabel: {
        fontSize: '13px',
        color: 'grey.700',
    } as SxProps<Theme>,
    priceHint: {
        fontSize: '11px',
        color: 'grey.500',
    } as SxProps<Theme>,
    pricesList: {
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
    } as SxProps<Theme>,
    totalRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mt: 0.25,
    } as SxProps<Theme>,
    totalLabel: { fontSize: '14px', fontWeight: 600, color: 'grey.900' } as SxProps<Theme>,
    totalValue: { fontSize: '16px', fontWeight: 700, color: 'grey.900' } as SxProps<Theme>,
    mediaInputRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        gap: 1,
        alignItems: 'center',
    } as SxProps<Theme>,
    mediaRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
        mt: 1,
        alignItems: 'center',
    } as SxProps<Theme>,
    mediaChip: (theme: Theme): SxProps<Theme> => ({
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        px: 1,
        py: 0.5,
        borderRadius: '6px',
        background: theme.palette.grey[40],
        fontSize: '12px',
    }),
    mediaThumb: {
        width: 56,
        height: 56,
        borderRadius: '6px',
        objectFit: 'cover',
        display: 'block',
    } as Record<string, unknown>,
    uploadBtn: (theme: Theme): SxProps<Theme> => ({
        textTransform: 'none',
        color: theme.palette.blue[700],
        borderColor: theme.palette.blue[700],
        whiteSpace: 'nowrap',
        flexShrink: 0,
    }),
    uploadError: {
        mt: 1,
        fontSize: '12px',
        color: 'red.main',
    } as SxProps<Theme>,
    hiddenInput: { display: 'none' } as Record<string, unknown>,
    actions: {
        display: 'flex',
        justifyContent: 'center',
        py: 1,
    } as SxProps<Theme>,
    doneBtn: (theme: Theme): SxProps<Theme> => ({
        backgroundColor: theme.palette.blue[700],
        color: theme.palette.white,
        py: 1.25,
        width: '85%',
        textTransform: 'none',
        '&:hover': { backgroundColor: theme.palette.blue[800] },
    }),
};
